"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = exports.ButtonGroup = exports.Title = exports.Logo = exports.Container = exports.Icon = exports.ButtonLink = exports.StyledHeader = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// components
//
const MalomoButton_1 = require("components/Dashboard/MalomoButton");
const StyledFeatherIcon_1 = require("components/Dashboard/NavigationSidebar/StyledFeatherIcon");
//
// properties
//
const config_1 = require("assets/styles/config");
exports.StyledHeader = styled_components_1.default.header `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 29px;
  padding-right: 24px;
  background-color: ${config_1.colors.white};
`;
exports.ButtonLink = styled_components_1.default.button `
  padding: 0;
  transition: color 0.1s linear;
  border: none;
  background-color: transparent;
  background-image: none;
  color: ${config_1.colors.black};
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  touch-action: manipulation;
  user-select: none;

  &:focus,
  &:hover {
    color: ${config_1.colors.black};
  }
`;
exports.Icon = (0, styled_components_1.default)(StyledFeatherIcon_1.StyledFeatherIcon) `
  font-size: 24px !important;
`;
exports.Container = styled_components_1.default.h1 `
  display: flex;
  align-items: center;
`;
exports.Logo = styled_components_1.default.img `
  width: auto;
`;
exports.Title = styled_components_1.default.span `
  color: ${config_1.colors.black};
  font-family: ${config_1.fontFamilies.primary};
  font-size: 13px;
  font-weight: normal;
`;
exports.ButtonGroup = styled_components_1.default.div `
  display: flex;
`;
exports.Button = (0, styled_components_1.default)(MalomoButton_1.MalomoButton) `
  height: 32px;
  padding: 7px 8px;
  font-family: ${config_1.fontFamilies.primary};
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;

  &:first-of-type {
    margin-right: 8px;
  }
`;
